export const triggerActionOnEscape = (callback) => (evt) => {
    evt.stopPropagation();
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) {
        isEscape = evt.key === "Escape" || evt.key === "Esc";
    } else {
        isEscape = evt.keyCode === 27;
    }
    if (isEscape) {
        return callback();
    }
};
